/* eslint-disable react/prop-types */
import * as React from "react";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ButtonBase from "@mui/material/ButtonBase";

/**
 * ServicesWidgetItem component - Displays a single service/workflow item
 * @param {Object} props - Component props
 * @param {string} props.name - Service name
 * @param {string} props.to - Route to navigate to
 * @param {string} props.description - Service description
 * @return {JSX.Element} ServicesWidgetItem component
 */
function ServicesWidgetItem({ name, to, description }) {
  return (
    <ButtonBase
      component={Link}
      to={to}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        p: "25px",
        mb: "20px",
        boxShadow: 3,
        "&:hover": {
          boxShadow: "inset 10px -10px 90px 41px rgba(58,112,155,0.1);",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          maxWidth: "15vw",
        }}
      >
        <Typography variant="h6" color="black">
          {name}
        </Typography>
        <Typography variant="body2" color="#686b6d">
          {description}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "5px",
          width: "75px",
          height: "75px",
          backgroundImage: "linear-gradient(to top, #e6e9f0 0%, #eef1f5 100%);",
        }}
      >
        <ArrowForwardIosRoundedIcon
          color="black"
          sx={{
            fontSize: 20,
          }}
        />
      </Box>
    </ButtonBase>
  );
}

export default ServicesWidgetItem;
